import { SourcesTable } from './SourcesTable'

export default SourcesTable
